import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { ActivatedRoute, Router } from '@angular/router';
import { IGovService } from './igov.service';

@Injectable({
    providedIn: 'root'
})
export class IGAEADMeetingsService {

    public headers;

    constructor(
        private http: HttpClient,
        private router: Router,
        private currentRoute: ActivatedRoute,
        private igvoService: IGovService
    ) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    }

    getBreadcrumbTitle(body) {
        //let body = this.currentRoute.snapshot.paramMap.get('body')
        let bodyName =''
        switch(body){
            case 'plenary' :
                bodyName='Plenary';
                break;
            case 'c1' :
                bodyName='First Committee';
                break;
            case 'c2' :
                bodyName='Second Committee';
                break;
            case 'c3' :
                bodyName='Third Committee';
                break;
            case 'c4' :
                bodyName='Fourth Committee';
                break;
            case 'c5' :
                bodyName='Fifth Committee';
                break;
            case 'c6' :
                bodyName='Sixth Committee';
                break;
            case 'wgsr' :
                bodyName='Working Group on the Strengthening and Revitalizing of the Work of the General Assembly';
                break;
            case 'c34' :
                bodyName='Special Committee on Peacekeeping Operations';
                break;
            case 'c24' :
                bodyName='Special Committee on the Situation with regard to the Implementation of the Declaration on the Granting of Independence to Colonial Countries and Peoples';
                break;
            case 'ffd4pc' :
                bodyName='Preparatory Committee for the Fourth International Conference on Financing for Development';
                break;
            case 'ffd4' :
                bodyName='Fourth International Conference on Financing for Development';
                break;
            case 'ungegn' :
                bodyName='United Nations Group of Experts on Geographical Names';
                break;
            case 'ggim':
                bodyName='Committee of Experts on Global Geospatial Information Management';
                break;
            case 'unff' :
                bodyName='United Nations Forum on Forests';
                break;
            case 'hlpf' :
                bodyName='High-level political forum on sustainable development, convened under the auspices of the Council';
                break;
            case 'ecosoc' :
                bodyName='Economic and Social Council';
                break;
            case 'csw' :
                bodyName='Commission on the Status of Women';
                break;
            case 'unpfii':
                bodyName='Permanent Forum on Indigenous Issues';
                break;
            case 'csocd':
                bodyName='Commission for Social Development';
                break;
            case 'statscomm':
                bodyName='Statistical Commission';
                break;
            case 'cngos':
                bodyName='Committee on Non-Governmental Organizations';
                break;
            case 'undc':
                bodyName='Disarmament Commission';
                break;
            case 'cpd': 
                bodyName= 'Commission on Population and Development';
                break;
            case 'ffd': 
                bodyName= 'Forum on financing for development follow-up';
                break;
            case 'bms': 
                bodyName= 'Biennial Meeting on Small Arms';
                break;
            case 'unwrapc' : 
                bodyName='UNWRA Pledging Conference'
                break;
        }
        return bodyName;
    }

    getBody(body, mainBody) {
        if(body == 'plenary' && mainBody=='GA'){
            return 'GA'
        }
        if(body == 'c3'){
            return 'Third Committee'
        }
        if(body=='c2'){
            return 'Second Committee'
        }
        if(body=='c1'){
            return 'First Committee'
        }
        if(body=='c4'){
            return 'Fourth Committee'
        }
        if(body=='c5'){
            return 'Fifth Committee'
        }
        if(body=='c6'){
            return 'Sixth Committee'
        }
        if(body=='wgsr'){
            return 'wgsr'
        }
        if(body=='c34'){
            return 'C34'
        }
        if(body=='c24'){
            return 'C-24'
        }
        if(body=='undc'){
            return 'UNDC'
        }
        if(body=='ffd4pc'){
            return 'Preparatory Committee for the Fourth International Conference on Financing for Development'
        }
        if(body=='ffd4'){
            return 'Fourth International Conference on Financing for Development'
        }
        if(body=='hlpf'){
            return 'High-level political forum on sustainable development, convened under the auspices of the Council';
        }
        if(body=='plenary' && mainBody=='Economic and Social Council'){
            return 'ECOSOC'
        }
        if(body=='csw' && mainBody=='Economic and Social Council'){
            return 'CSW'
        }
        if(body=='unpfii' && mainBody=='Economic and Social Council'){
            return 'UNPFII';
        }
        if(body=='csocd' && mainBody=='Economic and Social Council'){
            return 'CSOCD';
        }
        if(body=='statscomm' && mainBody=='Economic and Social Council'){
            return 'Statistical Commission';
        }
        if(body=='cngos' && mainBody=='Economic and Social Council'){
            return 'CNGOs';
        }
        if(body =='unwrapc'){
            return 'UNWRA Pledging Conference'
        }
        return body.toUpperCase()
    }

    getMeetingDetailBody(body) {
        if(body == 'ga'){
            return 'GA'
        }
        if(body == 'c.3'){
            return 'Third Committee'
        }
        if(body == 'c.2'){
            return 'Second Committee'
        }
        if(body == 'c.1'){
            return 'First Committee'
        }
        if(body=='c.4'){
            return 'Fourth Committee'
        }
        if(body=='c.5'){
            return 'Fifth Committee'
        }
        if(body=='c.6'){
            return 'Sixth Committee'
        }
        if(body=='wgsr'){
            return 'wgsr'
        }
        if(body=='ffd4pc'){
            return 'Preparatory Committee for the Fourth International Conference on Financing for Development'
        }
        if(body=='ffd4'){
            return 'Fourth International Conference on Financing for Development'
        }
        if(body=='hlpf'){
            return 'HLPF';
        }
        if(body=='plenary'){
            return 'ECOSOC'
        }
        if(body=='csw'){
            return 'CSW'
        }
        if(body=='c24'){
            return 'C-24'
        }
        if(body=='c34'){
            return 'C34'
        }
        if(body=='undc'){
            return 'UNDC'
        }
        if(body=='unpfii'){
            return 'UNPFII';
        }
        if(body=='csocd'){
            return 'CSOCD';
        }
        if(body=='unff'){
            return 'UNFF';
        }
        if(body=='statscomm'){
            return 'Statistical Commission';
        }
        if(body=='cngos'){
            return 'CNGOs';
        }
        if(body == 'cpd'){ 
            return 'CPD';
        }
        if(body == 'ffd'){ 
            return 'FFD';
        }
        if(body == 'ggim'){
            return 'GGIM';
        }
        if(body == 'bms'){
            return 'BMS';
        }
        if(body=='unwrapc'){
            return 'UNWRA Pledging Conference'
        }
        return ;
    }
    getResolutionsReportData(data: any) {
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.post(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/get-resolutions-report-data?env=${env}`, data, {headers: this.headers});
    }

    getVotesData(id: any) {
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/get-evotes/${id}?env=${env}`, {headers: this.headers});
    }

    getVotesDataByDoc(doc: any) {
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/votes/get-evotes-by-docsymbol?docSymbol=${doc}`, {headers: this.headers});
    }

    getSponserData(doc){
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/sponsership?document=${doc}`, {headers: this.headers});
    }

    getMeetingByNumber(body, session, number){
        if(number.at(-1)=='r'){
            number = number.substr(0, number.length - 1) +' (resumed)'
        }
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/meetingbymeetingno/${body}/${session}/${number}`, {headers: this.headers});
    }

    getScheduleReportData(data: any) {
        const env = EnvironmentLoader.environment.branch;
        return this.http.post(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/get-schedule-report-data?env=${env}`, data, { headers: this.headers });
    }

    getMeeingBySession(session, body='GA') {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/getbysession/${session}?body=${this.getCommittee(body)}`, {headers: this.headers});
    }

    getMeetingByAgenda(currentSession, body,agenda){
        const env = EnvironmentLoader.environment.branch;
        currentSession = currentSession == 'is' ? 'IS' : currentSession;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/getbyagenda/${currentSession}/${body}/`+agenda, {headers: this.headers});
    }

    getUnDocUrl(defaultLang, symbol){
        return `${EnvironmentLoader.environment.igovAuthEndpoint}/undoc?lang=${defaultLang}&symbol=${symbol}`;
    }

    getCommittee(body){
        let url =this.router.url.split('/');
        if(url[1]=='ga' && body == 'plenary'){
            return 'GA'
        }
        if(url[1]=='ga' && body=='c3'){
            return 'Third Committee'
        }
        if(url[1]=='ga' && body=='c2'){
            return 'Second Committee'
        }
        if(url[1]=='ga' && body=='c1'){
            return 'First Committee'
        }
        if(url[1]=='ga' && body=='c4'){
            return 'Fourth Committee'
        }
        if(url[1]=='ga' && body=='c5'){
            return 'Fifth Committee'
        }
        if(url[1]=='ga' && body=='c6'){
            return 'Sixth Committee'
        }
        if(url[1]=='ga' && body=='wgsr'){
            return 'wgsr'
        }
        if(url[1]=='ga' && body=='c34'){
            return 'C34'
        }
        if(url[1]=='ga' && body=='c24'){
            return 'C-24'
        }
        if(url[1]=='ga' && body=='undc'){
            return 'UNDC'
        }
        if(url[1]=='conferences' && body=='ffd4pc'){
            return 'Preparatory Committee for the Fourth International Conference on Financing for Development'
        }
        if(url[1]=='ecosoc' && body=='hlpf'){
            return 'HLPF';
        }
        if(url[1]=='conferences' && body=='ffd4'){
            return 'Fourth International Conference on Financing for Development'
        }
        if(url[1]=='ecosoc' && body=='plenary'){
            return 'ECOSOC'
        }
        if(url[1]=='ecosoc' && body=='unpfii'){
            return 'UNPFII'
        }
        if(url[1]=='ecosoc' && body=='csocd'){
            return 'CSOCD'
        }
        if(url[1]=='ecosoc' && body=='statscomm'){
            return 'Statistical Commission'
        }
        if(url[1]=='ecosoc' && body=='cngos'){
            return 'CNGOs'
        }
        if(body=='unwrapc'){
            return 'UNWRA Pledging Conference'
        }
        return body.toUpperCase();
    }

    getAgendaMeetingBody(body){
        let locationPath =this.router.url.split('/');
        if(locationPath[1]=='ga' && body == 'plenary'){
            return 'GA'
        }
        else if(locationPath[1]=='ga' && body !== 'plenary'){
            return this.getCommittee(body);
        }
        else if(locationPath[1]=='ecosoc' && body == 'plenary'){
            return this.getCommittee(body);
        }
        else if(locationPath[2]=='ffd4pc'){
            return 'Preparatory Committee for the Fourth International Conference on Financing for Development';
        }
        else if(locationPath[2]=='ffd4'){
            return 'Fourth International Conference on Financing for Development';
        }
        else if(locationPath[2]==  'statscomm'){
            return 'Statistical Commission'
        }
        else{
            return locationPath[2].toUpperCase();
        }
    }

    getDocument(currentSession, body='GA') {
        const env = EnvironmentLoader.environment.branch;
        currentSession = currentSession == 'is' ? 'IS' : currentSession;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/getdocumentsbysession/${currentSession}?body=${this.getCommittee(body)}`, {headers: this.headers});
    }
    getDocumentByAgenda(currentSession, agenda, body='GA') {
        const env = EnvironmentLoader.environment.branch;
        currentSession = currentSession == 'is' ? 'IS' : currentSession;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/getdocumentsbysession/${currentSession}/${agenda}?body=${body}`, {headers: this.headers});
    }

    getProcedureStep(currentSession, body, agenda) {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/meetings/getproceduresteps/${currentSession}/${body}/${agenda}`, {headers: this.headers});
    }

    allLanguages: string[] = ['ar', 'zh', 'fr', 'ru', 'es'];
    getTranslations(lines: { hash: string; value: string }[]) {
        let defaultLang = localStorage.getItem('defaultLanguage') || 'en';
        if (defaultLang === 'en') return;
        if (!this.allLanguages.includes(defaultLang)) return;

        return this.http.post(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/integration/public/api/get-translations`, { language: defaultLang, lines }, { headers: this.headers }).toPromise();
        // return this.http.post(`http://127.0.0.1:3060/igov/api/e-delegate/integration/public/api/get-translations`, { language: defaultLang, lines }, { headers: this.headers }).toPromise();
    }
}
